import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ActivityFeedItem = ({ activity }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'content':
        return 'FileEdit';
      case 'publish':
        return 'Upload';
      case 'user':
        return 'UserPlus';
      case 'seo':
        return 'TrendingUp';
      case 'security':
        return 'Shield';
      default:
        return 'Activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'content':
        return 'text-primary bg-primary/10';
      case 'publish':
        return 'text-success bg-success/10';
      case 'user':
        return 'text-accent bg-accent/10';
      case 'seo':
        return 'text-warning bg-warning/10';
      case 'security':
        return 'text-error bg-error/10';
      default:
        return 'text-muted bg-muted';
    }
  };

  const formatTimestamp = (timestamp) => {
    const now = new Date();
    const activityTime = new Date(timestamp);
    const diffMs = now - activityTime;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    return `${diffDays}d ago`;
  };

  return (
    <div className="flex items-start gap-3 md:gap-4 p-3 md:p-4 hover:bg-muted/50 rounded-lg transition-colors duration-200">
      <div className={`p-2 rounded-lg flex-shrink-0 ${getActivityColor(activity?.type)}`}>
        <Icon name={getActivityIcon(activity?.type)} size={16} className="md:w-5 md:h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2 mb-1">
          <p className="text-xs md:text-sm text-foreground font-medium line-clamp-2">{activity?.title}</p>
          <span className="text-xs text-muted-foreground whitespace-nowrap flex-shrink-0">
            {formatTimestamp(activity?.timestamp)}
          </span>
        </div>
        <p className="text-xs md:text-sm text-muted-foreground line-clamp-2 mb-2">{activity?.description}</p>
        
        {activity?.user && (
          <div className="flex items-center gap-2">
            <Image
              src={activity?.user?.avatar}
              alt={activity?.user?.avatarAlt}
              className="w-5 h-5 md:w-6 md:h-6 rounded-full object-cover"
            />
            <span className="text-xs text-muted-foreground">{activity?.user?.name}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityFeedItem;